import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { images } from "../../i18n/translations";
import { Reveal } from "../ui/Reveal";
export function CallToAction() {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full overflow-hidden" data-id="element-139" data-mp="l7bwy8enlsgm">
      <img src={images.cta} alt="Flota de maquinaria pesada en operación" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-140" data-mp="l5r3km42sfkc" />
      <div className="absolute inset-0 bg-navy-dark/85" aria-hidden="true" data-id="element-141" data-mp="v4qe6a8eil9z" />
      <div className="relative max-w-content mx-auto px-4 sm:px-6 py-20 sm:py-28 text-center" data-id="element-142" data-mp="18vlegy4u3u1y">
        <Reveal className="mx-auto max-w-3xl" data-id="element-143" data-mp="14ut7ycnck39d">
          <h2 className="font-heading font-bold uppercase text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05]" data-id="element-144" data-mp="14x5ul341v1sr">
            {t.cta.headline}
          </h2>
          <p className="mt-5 text-slate-200 text-lg leading-relaxed" data-id="element-145" data-mp="1dx2e6qbl1agy">{t.cta.subtitle}</p>
          <a href="#contacto" className="mt-9 inline-flex items-center justify-center gap-2 rounded-sm bg-orange px-8 py-4 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-orange-dark" data-id="element-146" data-mp="1erzuu0qhgwgn">
            {t.cta.button}
            <ArrowRightIcon size={18} data-id="element-147" data-mp="1sr90i6h2c86d" />
          </a>
        </Reveal>
      </div>
    </section>;
}